import {Beneficiary, BeneficiaryType} from '@simpleinvest/ms-custodian-sdk';
// eslint-disable-next-line import/no-cycle
import {ModifiedAccountRequest} from '@client/services/accountRequest';
import {Constants} from '@client/util/constants';

interface StandardAddress {
  streetAddress: string[];
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

interface AddressFields {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  country?: string;
}

export const convertToStandardBeneficiaryAddress = ({
  addressLine1,
  addressLine2 = null,
  city,
  state,
  postalCode,
  country = 'USA',
}: AddressFields): StandardAddress => {
  const streetAddress: string[] =
    addressLine2 === null || addressLine2 === '' ? [addressLine1] : [addressLine1, addressLine2];

  const address = {
    streetAddress,
    city,
    state,
    postalCode,
    country,
  };

  return address;
};

export const convertNewBeneficiariesForReturningUser = (
  accounts: ModifiedAccountRequest[]
): Record<number, Beneficiary[]> => {
  const formattedBeneficiaryObject = {};

  accounts.forEach((account) => {
    const {request_id: accountRequestId, beneficiaries} = account;

    const formattedBeneficiaries =
      beneficiaries?.map((beneficiary) => {
        const beneficiaryType = beneficiary.beneficiaryType ?? BeneficiaryType.Contingent;

        return {
          ...beneficiary,
          address: {
            ...beneficiary?.address,
            country: Constants.DEFAULT_COUNTRY,
          },
          beneficiaryType: beneficiaryType.toUpperCase(),
        };
      }) ?? [];

    formattedBeneficiaryObject[accountRequestId] = formattedBeneficiaries;
  });

  return formattedBeneficiaryObject;
};
